<template>
    <div v-if="props.advisory" class="main-div">
        <div class="header-div">
            <div class="back-div" @click="handleBack">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M2.68281 10.4422L8.30781 16.0672C8.42509 16.1845 8.58415 16.2504 8.75 16.2504C8.91585 16.2504 9.07491 16.1845 9.19219 16.0672C9.30946 15.9499 9.37535 15.7909 9.37535 15.625C9.37535 15.4592 9.30946 15.3001 9.19219 15.1828L4.63359 10.625H16.875C17.0408 10.625 17.1997 10.5592 17.3169 10.442C17.4342 10.3247 17.5 10.1658 17.5 10C17.5 9.83425 17.4342 9.67528 17.3169 9.55807C17.7997 9.44086 17.0408 9.37501 16.875 9.37501H4.63359L9.19219 4.8172C9.30946 4.69992 9.37535 4.54086 9.37535 4.37501C9.37535 4.20916 9.30946 4.0501 9.19219 3.93282C9.07491 3.81555 8.91585 3.74966 8.75 3.74966C8.58415 3.74966 8.42509 3.81555 8.30781 3.93282L2.68281 9.55782C2.6247 9.61587 2.5786 9.6848 2.54715 9.76067C2.5157 9.83655 2.49951 9.91788 2.49951 10C2.49951 10.0821 2.5157 10.1635 2.54715 10.2393C2.5786 10.3152 2.6247 10.3842 2.68281 10.4422Z"
                        fill="#2563F3"
                    />
                </svg>
                <span>Go Back</span>
            </div>
        </div>
        <div class="main-inc">
            <div class="header">
                <div class="title-div">
                    <div class="badge-div">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M18.4999 14.6945L11.6678 2.82968C11.4971 2.53899 11.2534 2.29797 10.9608 2.13051C10.6682 1.96304 10.337 1.87494 9.99986 1.87494C9.66275 1.87494 9.33149 1.96304 9.03892 2.13051C8.74635 2.29797 8.50262 2.53899 8.33189 2.82968L1.49986 14.6945C1.33559 14.9757 1.24902 15.2955 1.24902 15.6211C1.24902 15.9467 1.33559 16.2665 1.49986 16.5476C1.6684 16.8401 1.91171 17.0824 2.20483 17.2498C2.49795 17.4171 2.83032 17.5035 3.16783 17.5H16.8319C17.1691 17.5032 17.5012 17.4167 17.794 17.2494C18.0868 17.082 18.3299 16.8399 18.4983 16.5476C18.6628 16.2666 18.7496 15.9469 18.7499 15.6213C18.7502 15.2957 18.6639 14.9758 18.4999 14.6945ZM9.37486 8.12499C9.37486 7.95923 9.44071 7.80026 9.55792 7.68305C9.67513 7.56584 9.8341 7.49999 9.99986 7.49999C10.1656 7.49999 10.3246 7.56584 10.4418 7.68305C10.559 7.80026 10.6249 7.95923 10.6249 8.12499V11.25C10.6249 11.4158 10.559 11.5747 10.4418 11.6919C10.3246 11.8091 10.1656 11.875 9.99986 11.875C9.8341 11.875 9.67513 11.8091 9.55792 11.6919C9.44071 11.5747 9.37486 11.4158 9.37486 11.25V8.12499ZM9.99986 15C9.81444 15 9.63319 14.945 9.47901 14.842C9.32484 14.739 9.20468 14.5926 9.13372 14.4213C9.06277 14.2499 9.0442 14.0615 9.08038 13.8796C9.11655 13.6977 9.20584 13.5307 9.33695 13.3996C9.46806 13.2685 9.63511 13.1792 9.81696 13.143C9.99882 13.1068 10.1873 13.1254 10.3586 13.1964C10.5299 13.2673 10.6763 13.3875 10.7794 13.5416C10.8824 13.6958 10.9374 13.8771 10.9374 14.0625C10.9374 14.3111 10.8386 14.5496 10.6628 14.7254C10.487 14.9012 10.2485 15 9.99986 15Z"
                                fill="#E74341"
                            />
                        </svg>
                        <span>{{ getAdvisoryTypeDisplay(props.advisory.type) }}</span>
                    </div>
                    <div class="timed-div hidden lg:block">{{ formatAdvisoryDate(props.advisory.created_at) }}</div>
                </div>
                <PrimeTag>
                    {{ props.advisory.id }}
                </PrimeTag>
            </div>
            <div class="divider"></div>
            <div class="desc-div">
                <div v-if="props.advisory.title" class="advisory-title">
                    <h2>{{ props.advisory.title }}</h2>
                </div>
                <div v-if="props.advisory.html" class="advisory-content">
                    <div v-html="props.advisory.html"></div>
                </div>
                <div v-else class="advisory-content">
                    <Overview />
                    <Technical />
                    <Mitigation />
                    <Recommendations />
                    <NextSteps />
                </div>
            </div>
        </div>
    </div>
    <SharedSpinner v-else label="Loading advisory..." />
</template>

<script setup lang="ts">
import Mitigation from '~/components/main/person/companies/CompanyAdvisories/Mitigation.vue';
import NextSteps from '~/components/main/person/companies/CompanyAdvisories/NextSteps.vue';
import Overview from '~/components/main/person/companies/CompanyAdvisories/Overview.vue';
import Recommendations from '~/components/main/person/companies/CompanyAdvisories/Recommendations.vue';
import Technical from '~/components/main/person/companies/CompanyAdvisories/Technical.vue';
import { useDateHelpers } from '~/composables/useDateHelpers';
import type { CompanyAdvisory } from '~/types/person/companies';

const props = defineProps<{
    advisory: CompanyAdvisory | null;
}>();

const emit = defineEmits(['handleShowSpecificIncident']);

const { formatDate } = useDateHelpers();

const handleBack = () => {
    emit('handleShowSpecificIncident');
};

const formatAdvisoryDate = (dateString: string) => {
    return formatDate(dateString, 'MMMM Do, YYYY');
};

const getAdvisoryTypeDisplay = (type: string) => {
    return type.split('_').map((word: string) => 
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
};
</script>

<style lang="scss" scoped>
.main-div {
    @apply flex flex-col gap-7;
}

.header-div {
    @apply flex justify-start items-center shrink-0;

    .back-div {
        @apply flex justify-center items-center gap-2 cursor-pointer;

        span {
            @apply text-sm leading-5 font-semibold text-blue-600 font-inter;
        }
    }
}

.main-inc {
    @apply flex flex-col items-start gap-4 py-5 px-6 self-stretch rounded-md border border-gray-200 bg-white shadow-sm overflow-hidden;
}

.header {
    @apply flex items-center gap-2 py-1 w-full sm:flex-row flex-col ;
}

.title-div {
    @apply justify-between flex items-center gap-2 flex-1;
}

.badge-div {
    @apply flex items-center gap-2 px-1.5 py-0.5 pl-1;

    span {
        @apply text-red-500 text-center font-inter text-sm font-medium leading-5;
    }
}

.timed-div {
    @apply block text-right font-inter text-xs font-normal leading-5 text-zinc-500;
}

.pb-num {
    @apply flex items-center px-1.5 py-0.5 rounded border border-zinc-300 bg-white shadow-sm;

    span {
        @apply text-zinc-700 text-center font-inter text-xs font-medium leading-5;
    }
}

.divider {
    @apply h-px flex-shrink-0 self-stretch bg-gray-200;
}

.desc-div {
    @apply flex flex-col items-start gap-9 w-full;
    
    .advisory-title {
        @apply w-full;
        
        h2 {
            @apply text-2xl font-bold text-gray-900 mb-4;
        }
    }
    
    .advisory-content {
        @apply w-full overflow-hidden;

        :deep(*) {
            @apply max-w-full;
        }

        :deep(p) {
            @apply mb-4 text-gray-700 leading-relaxed break-words;
        }

        :deep(strong) {
            @apply font-semibold text-gray-900;
        }

        :deep(ul) {
            @apply mb-4 pl-6 list-disc;
        }
        :deep(ol) {
            @apply mb-4 pl-6 list-decimal;
        }

        :deep(li) {
            @apply mb-2 text-gray-700 break-words;
        }

        :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
            @apply break-words;
        }

        :deep(pre), :deep(code) {
            @apply overflow-x-auto;
        }

        :deep(a) {
            @apply break-words break-all;
        }
    }
}

</style>
